import { BuzerIcon } from "../../../BuzerIcons";

// Round icon button — the shared circle affordance used for list actions
// (message/chevron), the sheet close (ghost), row delete (destructive) and the
// create/FAB action (primary). variant sets the tone; size sets the diameter.
// Pass a BuzerIcon name via `icon`, or arbitrary children.
export function IconButton({
  icon, variant = "neutral", size = "md", className = "",
  "aria-label": ariaLabel, children, ...rest
}) {
  const cls = ["bz-iconbtn", `bz-iconbtn--${variant}`, `bz-iconbtn--${size}`, className].filter(Boolean).join(" ");
  const glyph = size === "sm" ? 16 : size === "lg" ? 22 : 18;
  return (
    <button type="button" aria-label={ariaLabel} className={cls} {...rest}>
      {children || (icon && <BuzerIcon name={icon} size={glyph} color="currentColor" />)}
    </button>
  );
}
